/**
 * Searchable field input for the CALC wizard. Suggests codebook field paths
 * (from `CodebookFieldsContext`, provided by TransformView) but allows free
 * typing too — a derived field built by an earlier pipeline step won't be in
 * the codebook yet, and the user can still reference it by name.
 */
import React from "react"
import { AutoComplete } from "antd"
import { useCodebookFields } from "../CodebookContext"

interface CalcFieldPickerProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  style?: React.CSSProperties
}

const CalcFieldPicker: React.FC<CalcFieldPickerProps> = ({
  value,
  onChange,
  placeholder = "Field…",
  style,
}) => {
  const fields = useCodebookFields()
  return (
    <AutoComplete
      size="small"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{ minWidth: 220, ...style }}
      popupMatchSelectWidth={false}
      options={fields.map((f) => ({ value: f.value }))}
      filterOption={(input, option) =>
        String(option?.value ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  )
}

export default CalcFieldPicker
